import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Navimumbaitogoacab() {



const cardData = {
  keyword: " Navi Mumbai to Goa Cab Service ",

headingDescription: "Velocity Cab provides reliable and comfortable Navi Mumbai to Goa cab service, ensuring a smooth and stress‑free journey for family vacations, group trips, business travel, and leisure getaways. Our professional drivers, well‑maintained vehicles, and punctual pickups make long‑distance travel from Navi Mumbai to Goa convenient and enjoyable. The journey covers scenic coastal and highway routes, offering beautiful views along the way. We offer flexible booking options including one‑way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air‑conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Navi Mumbai to Goa cab service.",

topPlaces: [
  {
    title: "Baga Beach",
    description: "Baga Beach is one of Goa’s most popular beaches, known for its lively atmosphere, water sports, and beachside shacks. Travelers from Navi Mumbai by cab can relax on the sandy shores, enjoy parasailing, jet skiing, and explore cafes and nightlife spots. The vibrant beach area is perfect for both adventure and leisure."
  },
  {
    title: "Calangute Beach",
    description: "Calangute Beach, often called the ‘Queen of Beaches,’ is famous for its wide shoreline and bustling environment. Visitors arriving from Navi Mumbai can enjoy sunbathing, swimming, and sampling Goan seafood. The beach is surrounded by shops, restaurants, and market stalls, making it a great place for families and groups."
  },
  {
    title: "Anjuna Beach",
    description: "Anjuna Beach is known for its scenic beauty, rocky coastline, and vibrant flea markets. Travelers using a cab from Navi Mumbai can explore the local markets, enjoy beach parties, and capture stunning sea views. It’s especially popular with young travelers and backpackers."
  },
  {
    title: "Dudhsagar Waterfalls",
    description: "Dudhsagar Waterfalls is one of India’s tallest waterfalls, located near the Goa–Karnataka border. Visitors from Navi Mumbai can take a cab to this breathtaking natural attraction, trek through lush forests, and enjoy the powerful cascading water during the monsoon season. It’s ideal for nature lovers and photographers."
  },
  {
    title: "Fort Aguada",
    description: "Fort Aguada is a well‑preserved Portuguese fort overlooking the Arabian Sea. Travelers from Navi Mumbai can visit this historic site to explore its lighthouse, fort walls, and scenic viewpoints. It’s a great spot for photography and learning about Goa’s colonial history."
  },
  {
    title: "Basilica of Bom Jesus",
    description: "The Basilica of Bom Jesus in Old Goa is a UNESCO World Heritage Site famous for housing the remains of St. Francis Xavier. Travelers arriving by cab can admire its baroque architecture, explore the serene interior, and learn about its historical significance. It’s a must‑visit for culture and history enthusiasts."
  },
  {
    title: "Vagator Beach",
    description: "Vagator Beach is a picturesque beach known for its dramatic red cliffs and scenic beauty. Travelers using a cab from Navi Mumbai can enjoy peaceful beach walks, sunset views, and nearby cafes. It’s ideal for those seeking a relaxed beach experience away from crowds."
  },
  {
    title: "Colva Beach",
    description: "Colva Beach in South Goa is known for its calm waters, soft sands, and family‑friendly environment. Travelers from Navi Mumbai can visit this beach for swimming, water activities, and leisurely walks. It’s a favorite destination for families and couples alike."
  },
  {
    title: "Palolem Beach",
    description: "Palolem Beach is a serene and scenic beach in South Goa with a crescent‑shaped shoreline. Travelers from Navi Mumbai can unwind here, enjoy kayaking, dolphin spotting, and beachside dining. It’s perfect for visitors seeking tranquility and natural beauty."
  },
  {
    title: "Bambolim Beach",
    description: "Bambolim Beach is a quieter beach in Goa, ideal for visitors who prefer a peaceful seaside experience. Travelers arriving by cab from Navi Mumbai can enjoy quiet walks, cool sea breezes, and scenic views, making it a relaxing stop during the Goa trip."
  }
],



services: [
{
name: "Navi Mumbai to Goa Cab",
description: "Navi Mumbai to Goa cab service offers a comfortable and scenic road journey for travelers looking to explore Goa’s beautiful beaches, nightlife, and cultural attractions. This long-distance cab service is perfect for families, friends, couples, and corporate travelers who prefer a private and flexible travel experience. The journey from Navi Mumbai to Goa passes through lush green highways, ghats, and coastal routes, making it a memorable road trip. Professional drivers with experience in long-distance travel ensure safety and smooth driving throughout the journey. Customers can choose from a wide range of vehicles including sedan, SUV, and luxury options based on their comfort and budget. Doorstep pickup from areas like Vashi, Nerul, Belapur, Kharghar, and Panvel adds convenience. With transparent pricing, flexible travel options, and 24x7 booking availability, this cab service ensures a hassle-free Goa trip."
},
{
name: "Navi Mumbai to Goa Taxi Service",
description: "Navi Mumbai to Goa taxi service provides reliable and comfortable transportation for long-distance travel with well-maintained vehicles and skilled drivers. This service is ideal for travelers who want a stress-free journey with flexible pickup and drop options. Whether traveling for vacation or business, customers can enjoy a smooth ride with spacious seating and proper rest stops along the way. Multiple vehicle options such as sedan and SUV cater to different group sizes and budgets. Professional drivers ensure safe driving across highways and ghat sections. Transparent pricing and easy booking make it a preferred choice. It ensures a comfortable and enjoyable travel experience."
},
{
name: "One Way Cab Navi Mumbai to Goa",
description: "One way cab Navi Mumbai to Goa is a cost-effective option for travelers who need a single-side drop without paying for return charges. This service is perfect for tourists planning to stay in Goa or continue their journey further. Customers benefit from competitive pricing, flexible pickup timing, and a wide range of vehicle options. Professional drivers ensure safe and timely travel across long-distance routes. This option is ideal for both solo travelers and groups looking for affordable travel solutions. Online booking with instant confirmation makes the process simple and quick. It is one of the most convenient ways to travel to Goa."
},
{
name: "Navi Mumbai to Goa Cab Booking",
description: "Navi Mumbai to Goa cab booking allows customers to easily reserve their cab with instant confirmation and flexible scheduling. Travelers can choose their preferred vehicle type, pickup location, and travel date through simple online platforms. Transparent pricing ensures there are no hidden costs involved. Dedicated customer support is available to assist before and during the journey. This service ensures vehicle availability even during peak travel seasons. Flexible payment options make booking easy for all customers. It is the most convenient way to plan your Goa trip from Navi Mumbai."
},
{
name: "Navi Mumbai to Goa Taxi Fare",
description: "Navi Mumbai to Goa taxi fare is designed to be transparent and budget-friendly, helping travelers plan their journey efficiently. Pricing depends on vehicle type, travel distance, and trip duration. Customers receive a clear breakdown of charges including tolls and driver allowances where applicable. Affordable options are available for sedan, SUV, and premium vehicles. No hidden charges ensure trust and reliability for customers. Flexible fare options allow travelers to choose according to their budget. It offers excellent value for long-distance travel."
},
{
name: "Navi Mumbai to Goa Outstation Cab",
description: "Navi Mumbai to Goa outstation cab service provides reliable and comfortable travel solutions for long-distance trips. This service is ideal for tourists, families, and business travelers looking for safe and smooth transportation. Vehicles are regularly maintained for optimal performance on highways and hilly terrains. Flexible travel options include one way and round trip packages. Professional drivers ensure safe navigation through ghats and highways. It offers a hassle-free and enjoyable journey experience. It is a trusted option for Goa travel."
},
{
name: "Cheap Cab Navi Mumbai to Goa",
description: "Cheap cab Navi Mumbai to Goa offers budget-friendly travel options without compromising on comfort and safety. This service is perfect for travelers who want economical transportation for long-distance journeys. Sedan vehicles are available at affordable rates with transparent pricing. Professional drivers ensure safe and smooth travel across routes. Flexible booking options help customers choose according to their schedule. It is an ideal choice for budget-conscious travelers. It combines affordability with reliability."
},
{
name: "Navi Mumbai to Goa SUV Taxi",
description: "Navi Mumbai to Goa SUV taxi is ideal for travelers who prefer extra space, comfort, and power during long journeys. SUVs offer spacious seating and better road performance on highways and ghat sections. This option is suitable for families, groups, and corporate travelers. Professional drivers ensure safe and comfortable travel throughout the journey. It provides a premium travel experience with added comfort. Perfect for long-distance road trips. It ensures a smooth and enjoyable ride."
},
{
name: "Navi Mumbai to Goa Sedan Cab",
description: "Navi Mumbai to Goa sedan cab is a popular choice for small families and couples seeking a comfortable yet budget-friendly ride. Sedans offer smooth travel, good mileage, and comfortable seating for long journeys. This service is ideal for travelers who want economical travel without compromising convenience. Professional drivers ensure safe and efficient driving. Flexible pickup and drop options enhance convenience. It is one of the most preferred travel options. It ensures a pleasant journey experience."
},
{
name: "Navi Mumbai to Goa Car Rental",
description: "Navi Mumbai to Goa car rental service provides flexible travel solutions with a wide range of vehicles to choose from. Customers can rent cars for one way or round trips based on their requirements. This service is suitable for family vacations, corporate travel, and group trips. Easy booking process and transparent pricing make it convenient for customers. Vehicles are clean, well-maintained, and driven by experienced chauffeurs. Flexible pickup options from different Navi Mumbai locations add convenience. It ensures a comfortable and customized travel experience."
},
{
name: "Private Cab Navi Mumbai to Goa",
description: "Private cab Navi Mumbai to Goa offers a personalized travel experience with exclusive vehicle usage for families and groups. Travelers can customize routes, stops, and travel schedules according to their preferences. This ensures a relaxed and stress-free journey throughout the trip. Professional drivers provide safe and reliable service with complete privacy. Comfortable seating and premium service enhance the travel experience. It is ideal for private and luxury travel. It guarantees comfort and flexibility."
},
{
name: "AC Taxi Navi Mumbai to Goa",
description: "AC taxi Navi Mumbai to Goa ensures a comfortable journey in air-conditioned vehicles for long-distance travel. This service is ideal for travelers who prefer a pleasant and cool environment during the journey. Clean interiors and properly maintained AC systems enhance passenger comfort. Suitable for families, tourists, and business travelers. Flexible booking options make planning easy. Professional drivers ensure timely and safe service. It guarantees a relaxing travel experience."
},
{
name: "Book Navi Mumbai to Goa Cab Online",
description: "Book Navi Mumbai to Goa cab online for quick, easy, and hassle-free reservations with instant confirmation. Customers can select vehicle type, travel date, and pickup location through user-friendly platforms. Secure payment options and transparent pricing make the process convenient. This service ensures vehicle availability even during peak seasons. Dedicated support is available for assistance anytime. It simplifies travel planning for Goa trips. It is the most efficient booking option."
},
{
name: "Navi Mumbai to Goa Round Trip Cab",
description: "Navi Mumbai to Goa round trip cab service is ideal for travelers planning a return journey after their Goa visit. This package includes pickup, drop, waiting time, and return travel with flexible scheduling. Travelers can enjoy their trip without worrying about return transportation. Professional drivers ensure safe and timely service. Multiple vehicle options are available based on group size. It offers convenience and cost efficiency. It ensures a complete travel solution."
},
{
name: "Best Cab Service Navi Mumbai to Goa",
description: "Best cab service Navi Mumbai to Goa ensures a premium travel experience with well-maintained vehicles, professional drivers, and excellent customer support. This service focuses on safety, punctuality, and comfort for long-distance journeys. Customers can choose from a variety of vehicle options to suit their needs. Transparent pricing and easy booking enhance customer trust. It is a reliable choice for Goa travel from Navi Mumbai. It guarantees a smooth and enjoyable journey."
}
],

tableData: [
["Navi Mumbai to Goa Cab","Navi Mumbai to Goa Taxi Service"],
["One Way Cab Navi Mumbai to Goa","Navi Mumbai to Goa Cab Booking"],
["Navi Mumbai to Goa Taxi Fare","Navi Mumbai to Goa Outstation Cab"],
["Cheap Cab Navi Mumbai to Goa","Navi Mumbai to Goa SUV Taxi"],
["Navi Mumbai to Goa Sedan Cab","Navi Mumbai to Goa Car Rental"],
["Private Cab Navi Mumbai to Goa","AC Taxi Navi Mumbai to Goa"],
["Book Navi Mumbai to Goa Cab Online","Navi Mumbai to Goa Round Trip Cab"],
["Best Cab Service Navi Mumbai to Goa","Navi Mumbai to Goa Cab"]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Goa Travel Experience",
    WhyChoosedescription: "Velocity Cabs offers reliable Navi Mumbai to Goa cab service for a smooth and enjoyable journey, perfect for family vacations, group trips, and weekend getaways."
  },
  {
    WhyChooseheading: "Experienced Highway Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in long-distance routes from Navi Mumbai to Goa, ensuring safe driving, proper route selection, and timely travel."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs provides clear and transparent pricing for Navi Mumbai to Goa cab bookings. Customers receive full fare details including toll charges and driver allowance without hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our Navi Mumbai to Goa cab service operates 24/7. Whether you plan early morning travel or overnight journeys, we ensure reliable service anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well maintained, and regularly cleaned to provide a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way cab service, round-trip bookings, and multi-day Goa packages as per customer needs."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, luxury SUVs, and Tempo Travellers suitable for individuals, families, and group travelers."
  },
  {
    WhyChooseheading: "Trusted Outstation Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many customers for Navi Mumbai to Goa cab bookings due to punctual drivers, clean vehicles, and professional service."
  }
]
};

const faqData = [
  { question: "Do you provide Navi Mumbai to Goa cab service?", answer: "Yes, Velocity Cabs provides reliable cab services from Navi Mumbai to Goa for one-way and round-trip travel." },
  { question: "How far is Goa from Navi Mumbai?", answer: "The distance between Navi Mumbai and Goa is approximately 580 to 620 km and travel time is around 11 to 13 hours depending on traffic and route." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Navi Mumbai to Goa cab service operates 24/7." },
  { question: "Which vehicles are available for this route?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, luxury SUVs, and Tempo Travellers." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services from Navi Mumbai to Goa." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Navi Mumbai to Goa cabs online or through phone booking." },
  { question: "Do you provide pickup from home or hotel?", answer: "Yes, we provide doorstep pickup from homes, hotels, and offices across Navi Mumbai." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended especially during weekends and holiday travel periods." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohan Deshmukh",
    feedback:
      "A long but very enjoyable journey from Navi Mumbai to Goa. The cab was comfortable, the drive was smooth, and the travel experience felt relaxed throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Kulkarni",
    feedback:
      "The Navi Mumbai to Goa cab service was excellent. The vehicle was clean, the ride was steady, and the entire trip was handled very professionally.",
    rating: 5
  }
];
























const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];











const naviMumbaiGoaCabJSON = {
  "@context": "https://schema.org",
  "@type": "TouristTrip",
  "name": "Navi Mumbai to Goa Cab Service | Velocity Cabs",
  "description": "Book a private cab from Navi Mumbai to Goa for comfortable outstation travel. AC, Sedan, and SUV taxis available for one-way or round trips at affordable fares.",
  "provider": {
    "@type": "Organization",
    "name": "Velocity Cabs",
    "url": "https://www.velocitycabs.com/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Navi Mumbai, Maharashtra, India"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Navi Mumbai to Goa Cab Packages",
    "itemListElement": [
      {
        "@type": "Offer",
        "name": "One Way Cab from Navi Mumbai to Goa",
        "description": "Private cab from Navi Mumbai to Goa for one-way travel with AC/SUV/Sedan options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      },
      {
        "@type": "Offer",
        "name": "Round Trip Navi Mumbai to Goa Cab",
        "description": "Comfortable round-trip cab service from Navi Mumbai to Goa with private AC/SUV/Sedan options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      }
    ]
  }
};





  return (
    <div>
      

<Helmet>
  <title>Navi Mumbai to Goa Cab Service | Velocity Cabs +91 9136271336</title>
  <meta
    name="description"
    content="Book a private cab from Navi Mumbai to Goa for comfortable outstation travel. AC, Sedan, and SUV taxis available for one-way or round trips at affordable fares."
  />
  <script type="application/ld+json">
    {JSON.stringify(naviMumbaiGoaCabJSON)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/92.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Navimumbaitogoacab;